import { baseApi } from "./baseApi"
import type { TableDetail, TableCreatePayload, TableUpdatePayload } from "../../types/tables"

export const tablesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getTables: build.query<TableDetail[], void>({
      query: () => "/tables",
      providesTags: (result) =>
        result
          ? [...result.map((t) => ({ type: "Table" as const, id: t.id })), { type: "Table", id: "LIST" }]
          : [{ type: "Table", id: "LIST" }],
    }),
    getTable: build.query<TableDetail, string>({
      query: (id) => `/tables/${id}`,
      providesTags: (_res, _err, id) => [{ type: "Table", id }],
    }),
    createTable: build.mutation<TableDetail, TableCreatePayload>({
      query: (body) => ({ url: "/tables", method: "POST", body }),
      invalidatesTags: [{ type: "Table", id: "LIST" }],
    }),
    updateTable: build.mutation<TableDetail, TableUpdatePayload>({
      query: ({ id, ...body }) => ({ url: `/tables/${id}`, method: "PUT", body }),
      invalidatesTags: (_res, _err, arg) => [
        { type: "Table", id: arg.id },
        { type: "Table", id: "LIST" },
      ],
    }),
    deleteTable: build.mutation<void, string>({
      query: (id) => ({ url: `/tables/${id}`, method: "DELETE" }),
      invalidatesTags: (_res, _err, id) => [
        { type: "Table", id },
        { type: "Table", id: "LIST" },
      ],
    }),
  }),
})

export const {
  useGetTablesQuery,
  useGetTableQuery,
  useCreateTableMutation,
  useUpdateTableMutation,
  useDeleteTableMutation,
} = tablesApi
